import React, { useEffect, useState } from "react";
import Table from "../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { getItemList } from "./dependencies/action";
import TableColumn from "./dependencies/TableColumn";
import ReferalTrasactionModal from "./ReferalTransactionModal";
function Referal() {
  const [query, setQuery] = useState({ page: 1, size: 10 ,fromDate:'',toDate:''});
  const dispatch = useDispatch();
  const { ItemList, ItemTotalPage,TotalIncome } = useSelector((state) => state.referalUser);
console.log("ReferalItemlist",ItemList)
  const { user } = useSelector((state) => state.login)
  const [isCopied, setIsCopied] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(getItemList(query));
  }, [dispatch, query]);
  const handlePageChange = (page) => {
    setQuery({ ...query, page: page })
  }
  const handleCopyClick = (e) => {
    e.preventDefault()

    const textToCopy = `https://fever99.com/register/${user.refrelCode}`;

    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;

    document.body.appendChild(textArea);

    textArea.select();

    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Unable to copy to clipboard: ", err);
    } finally {
      document.body.removeChild(textArea);
    }


    setIsCopied(true);
  };
  const clearFilter=()=>{
    setQuery({
      page:1,
      size:10,
      fromDate:'',
      toDate:''
    })
  }
  const handleTotalIncomeClick = () => {
    setShowModal(true); 
  };

  const handleCloseModal = () => {
    setShowModal(false); 
  };

  return (
    <>
      <head>
        <title>Fever99</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </head>
      <div className="page-wrapper">
        <div className="content">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="col-sm-4 col-3">
              <h4 className="page-title">Refered User</h4>
            </div>

            <div
              className="col-sm-8 col-9 text-right m-b-20"
              style={{ textAlign: "end" }}
            >

              <a href="#0" className="btn btn-sm btn-success" onClick={handleCopyClick}>{isCopied ? `Copied` : `Copy link to refer`}: {user && user.refrelCode}</a>
            </div>
            <div className="row m-b-20">
          <div className="col-4">
            <label>From Date</label>
            <input
              type="date"
              name="fromDate"
              value={query.fromDate}
              className="form-control"
              onChange={(e) =>  setQuery(prevQuery => ({
                ...prevQuery,
                fromDate: e.target.value,
              }))}
            />
          </div>
          <div className="col-4">
            <label>To Date</label>
            <input
              type="date"
              name="toDate"
              value={query.toDate}
              min={query.fromDate}
              className="form-control"
              onChange={(e) =>  setQuery(prevQuery => ({
                ...prevQuery,
                toDate: e.target.value,
              }))}
            />
          </div>
          <div className="col-4">
            <button className="btn btn-danger ml-2 mt-4" 
            onClick={clearFilter}
            >
              Clear Filter
            </button>
          </div>
        </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3 pr-0 bg-white m-1">
              <div className="dash-widget d-flex "onClick={handleTotalIncomeClick} style={{ cursor: 'pointer' }}>
                <span className="dash-widget-bg2">
                  <i class="fas fa-rupee-sign"></i>
                </span>
                <div
                  className="dash-widget-info float-left pl-2 "
                  style={{ marginLeft: "5px" }}
                >
                  <p>Total Refferal Income</p>
                  <h4>Rs. {TotalIncome}</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <Table
                      columns={TableColumn({
                        pageNo: query.page - 1,
                        size: query.size,
                      })}
                      dataTable={ItemList}
                      totalRecord={ItemTotalPage}
                      onPageChange={handlePageChange}
                      onTableChange={() => { }}
                      keyField="_id"
                      sizePerPage={query.size}
                    // pageSizeChange={(value) => handlePageSizeChange(value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReferalTrasactionModal show={showModal} handleClose={handleCloseModal} userId={user._id}/>
    </>
  );
}

export default Referal;
